<template>
  <div class="cards" :class="{ 'cards--compact': compact }">
    <r-card
      v-for="card in cards"
      :key="card.id"
      @click="$emit('click', { card, event: $event })"
      :title="card.name"
      :text="card.description"
      :subtitle="card.subtitle"
      :button-text="card.buttonText || buttonText"
      :button-style="buttonStyle"
      :base64-image="card.logoBase64String"
      :icon-name="card.iconName"
      :active="card.active"
      :compact="compact"
    />
  </div>
</template>

<script>
import RCard from './RCard.vue'

export default {
  props: {
    cards: { type: Array },
    buttonText: { type: String, default: 'Uredi vzorec' },
    buttonStyle: { type: Boolean, default: true },
    compact: { type: Boolean, default: false },
  },
  components: { RCard },
}
</script>

<style lang="scss" scoped>
@import "app/assets/stylesheets/variables";

.cards {
  display: grid;
  place-content: center;
  grid-gap: 24px;
  grid-template-columns: repeat(auto-fill, minmax(270px, 270px));
  margin-top: 32px;
  text-align: left;

  &--compact {
    grid-gap: 16px;
    grid-template-columns: repeat(auto-fill, minmax(210px, 210px));
  }
}
</style>
